/**
 * Application version configuration
 * This is used for tracking updates and showing changelogs
 */

export const APP_VERSION = '3.67.0';
export const BUILD_DATE = '2026-10-03';

/**
 * Get version info from localStorage
 */
export const getStoredVersion = (): string | null => {
  return localStorage.getItem('app_version');
};

/**
 * Store current version in localStorage
 */
export const storeVersion = (): void => {
  localStorage.setItem('app_version', APP_VERSION);
};

/**
 * Check if app was updated since last visit
 */
export const wasAppUpdated = (): boolean => {
  const storedVersion = getStoredVersion();
  if (!storedVersion) {
    storeVersion();
    return false; // First visit, not an update
  }
  
  if (storedVersion !== APP_VERSION) {
    storeVersion();
    return true;
  }
  
  return false;
};

/**
 * Parse semantic version for comparison
 */
export const parseVersion = (version: string): { major: number; minor: number; patch: number } => {
  const [major, minor, patch] = version.split('.').map(Number);
  return { major, minor, patch };
};

/**
 * Compare versions: returns 1 if v1 > v2, -1 if v1 < v2, 0 if equal
 */
export const compareVersions = (v1: string, v2: string): number => {
  const ver1 = parseVersion(v1);
  const ver2 = parseVersion(v2);
  
  if (ver1.major !== ver2.major) return ver1.major > ver2.major ? 1 : -1;
  if (ver1.minor !== ver2.minor) return ver1.minor > ver2.minor ? 1 : -1;
  if (ver1.patch !== ver2.patch) return ver1.patch > ver2.patch ? 1 : -1;
  
  return 0;
};
